/**
 * có thuyết minh hay không
 * tvanh 22.04.2024
 */
export default {
  NoExplanation: 0
};